<template>
	<section class="quizzes-section">
		<div class="dashboard--main-box student-subaccount-box">
			<div class="row">
				<div class="col-md-4 px-0" v-if="checkUser">
					<v-select
						auto-select-first
						filled
						:items="institutes"
						v-model="currentIns"
						@change="changeInstitute"
						item-text="name"
						item-value="id"
						:label="$t('instituteName')"
						color="green"
					></v-select>
				</div>
				<v-card class="col-12 p-3 mb-5 search-box">
					<div class="row">
						<div class="col-6">
							<v-text-field
								v-model.number="search.quiz_id"
								type="number"
								:label="$t('tables.id')"
								filled
								clearable
								color="green"
							></v-text-field>
						</div>
						<div class="col-6">
							<v-select
								v-model="search.is_published"
								:items="availability"
								item-text="text"
								item-value="value"
								:label="$t('tables.availability')"
								filled
								clearable
								color="green"
							></v-select>
						</div>
						<div class="col-6">
							<v-text-field
								v-model="search.name"
								:label="$t('tables.name')"
								filled
								clearable
								color="green"
							></v-text-field>
						</div>
						<div class="col-6">
							<v-autocomplete
								auto-select-first
								clearable
								filled
								:items="courses"
								item-text="title"
								item-value="id"
								v-model="search.course"
								:label="$t('tables.courseName')"
								color="green"
							></v-autocomplete>
						</div>
						<div class="col d-flex justify-content-end align-items-center mb-1">
							<v-btn color="success" class="me-4" @click="searchQuizzes">
								{{ $t("search") }}
							</v-btn>
							<v-btn color="error" @click="clearQuizzes">
								{{ $t("clear") }}
							</v-btn>
						</div>
					</div>
				</v-card>
				<v-data-table
					:headers="tableHeaders"
					:items="quizzes"
					item-key="id"
					:footer-props="{
						'items-per-page-options': [10, 20, 30, 40, 50, 100],
					}"
					checkbox-color="green"
					:items-per-page="itemsPerPage"
					:server-items-length="totalQuizzes"
					no-data-text="No Available Data."
					:page="currentPage"
					@click:row="viewQuiz"
					@update:options="updateQuizzes"
					single-select
					show-select
					v-model="toggledQuiz"
				>
					<template v-slot:top>
						<v-toolbar flat>
							<v-toolbar-title>{{ $t("quizzes") }}</v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
							<v-spacer></v-spacer>
							<v-dialog v-model="previewDialog" max-width="1000px">
								<template v-slot:activator="{ attrs }">
									<v-btn
										color="primary"
										class="mb-2"
										v-bind="attrs"
										@click="previewQuiz"
										:disabled="!toggledQuiz.length"
									>
										<i class="fa-solid fa-file-pdf me-2"></i>
										{{ $t("preview") }}
									</v-btn>
								</template>

								<QuizModal
									:quiz="previewedQuiz"
									:questions="previewedQuestions"
									@closeDialog="closeDialog"
									:previewDialog="previewDialog"
								/>
							</v-dialog>

							<v-divider class="mx-4" inset vertical></v-divider>

							<v-btn
								color="primary"
								class="mb-2"
								@click="printQuiz"
								:disabled="!toggledQuiz.length"
							>
								<i class="fa-solid fa-print me-2"></i> {{ $t("print") }}
							</v-btn>

							<v-divider class="mx-4" inset vertical></v-divider>

							<v-dialog v-model="emailDialog" max-width="1000px">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										color="primary"
										class="mb-2"
										v-bind="attrs"
										v-on="on"
										:disabled="!toggledQuiz.length"
									>
										<i class="fa-solid fa-envelope me-2"></i> {{ $t("send") }}
									</v-btn>
								</template>
								<v-card>
									<v-card-title>
										<span class="text-h5">{{ sendQuizName }}</span>
										<v-spacer></v-spacer>
										<v-btn
											class="mx-2"
											small
											color="primary"
											@click="closeDialog"
										>
											<v-icon dark>
												mdi-window-close
											</v-icon>
										</v-btn>
									</v-card-title>
									<v-card-text>
										<v-tabs fixed-tabs background-color="green" dark>
											<v-tab>
												{{ $t("students") }}
											</v-tab>
											<v-tab>
												{{ $t("studentGroups") }}
											</v-tab>
											<!-- Students Lists -->
											<v-tab-item>
												<StudentsList
													:institute_id="currentIns"
													:quiz="toggledQuiz[0]"
													@closeConfirmation="closeConfirmation($event)"
													@closeDialog="closeDialog"
												/>
											</v-tab-item>
											<!-- Student Groups List -->
											<v-tab-item>
												<StudentGroupsList
													:institute_id="currentIns"
													:quiz="toggledQuiz[0]"
													@closeConfirmation="closeConfirmation($event)"
													@closeDialog="closeDialog"
												/>
											</v-tab-item>
										</v-tabs>
									</v-card-text>
								</v-card>
							</v-dialog>

							<v-divider class="mx-4" inset vertical></v-divider>

							<v-dialog v-model="quizDialog" max-width="800px">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										color="primary"
										dark
										class="mb-2"
										v-bind="attrs"
										v-on="on"
									>
										<i class="fa-solid fa-plus"></i> {{ $t("addNew") }}
									</v-btn>
								</template>
								<v-card>
									<v-card-title>
										<span class="text-h5">{{ dialogTitle }}</span>
										<v-spacer></v-spacer>
										<v-btn
											class="mx-2"
											small
											color="primary"
											@click="closeDialog"
										>
											<v-icon dark>
												mdi-window-close
											</v-icon>
										</v-btn>
									</v-card-title>

									<v-card-text>
										<v-container>
											<v-form
												ref="form"
												v-model="quizValidation"
												lazy-validation
											>
												<v-row>
													<v-col cols="12" sm="6" md="6">
														<v-text-field
															v-model="quiz.name"
															:label="$t('quiz.quizName')"
															:rules="quizFormRules.quizNameRules"
															color="green"
															:readonly="viewMode"
															:clearable="!viewMode"
														></v-text-field>
													</v-col>
													<v-col cols="12" sm="6" md="6">
														<v-autocomplete
															auto-select-first
															:items="courses"
															item-text="title"
															item-value="id"
															v-model="quiz.course.id"
															:label="$t('quiz.courseName')"
															:rules="quizFormRules.courseNameRules"
															color="green"
															:readonly="viewMode"
															:clearable="!viewMode"
														></v-autocomplete>
													</v-col>
													<v-col cols="12" sm="6" md="6">
														<v-text-field
															v-model.number="quiz.total_score"
															type="number"
															:rules="quizFormRules.totalScoreRules"
															:label="$t('quiz.totalScore')"
															color="green"
															:readonly="viewMode"
															:clearable="!viewMode"
														></v-text-field>
													</v-col>
													<v-col cols="12" sm="6" md="6">
														<v-text-field
															v-model.number="quiz.passing_score"
															type="number"
															:rules="quizFormRules.passScoreRules"
															:label="$t('quiz.passScore')"
															color="green"
															:readonly="viewMode"
															:clearable="!viewMode"
														></v-text-field>
													</v-col>
													<v-col cols="12" sm="6" md="4">
														<v-text-field
															v-model.number="quiz.duration_in_minutes"
															type="number"
															:rules="quizFormRules.timeRules"
															:label="$t('quiz.timeInMinutes')"
															color="green"
															:readonly="viewMode"
															:clearable="!viewMode"
														></v-text-field>
													</v-col>
													<v-col cols="12" sm="6" md="4">
														<v-text-field
															v-model.number="quiz.max_attempts"
															type="number"
															:rules="quizFormRules.maxTrialsRules"
															:label="$t('quiz.maximumTrials')"
															color="green"
															:readonly="viewMode"
															:clearable="!viewMode"
														></v-text-field>
													</v-col>
													<v-col cols="12" sm="6" md="4">
														<v-select
															v-model="quiz.is_published"
															:items="availability"
															:rules="quizFormRules.availabilityRules"
															:label="$t('quiz.availability')"
															item-text="text"
															item-value="text"
															color="green"
															:readonly="viewMode"
															editable
															:clearable="!viewMode"
														></v-select>
													</v-col>
													<v-col cols="12">
														<v-textarea
															v-model="quiz.description"
															auto-grow
															color="green"
															:label="$t('quiz.description')"
															rows="3"
															:readonly="viewMode"
														></v-textarea>
													</v-col>
												</v-row>
											</v-form>
											<small v-if="!viewMode" class="red--text">
												{{ $t("quiz.requiredField") }}
											</small>
										</v-container>
									</v-card-text>

									<v-card-actions v-if="!viewMode">
										<v-spacer></v-spacer>
										<v-btn color="red darken-1" text @click="closeDialog">
											{{ $t("Cancel") }}
										</v-btn>
										<v-btn
											color="green darken-1"
											text
											@click="addNewQuiz"
											:disabled="checkForm"
										>
											{{ formSubmission }}
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
							<v-dialog
								v-model="deleteDialog"
								persistent
								max-width="400px"
								transition="dialog-bottom-transition"
							>
								<v-card>
									<v-card-title class="text-h5">
										{{ $t("quiz.deleteQuiz") }}
									</v-card-title>

									<v-card-text class="pb-0">
										{{ $t("quiz.areYouSure") }}
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn color="blue darken-1" text @click="closeDialog">
											{{ $t("cancel") }}
										</v-btn>
										<v-btn
											color="blue darken-1"
											text
											@click="deleteQuizConfirmation()"
										>
											{{ $t("yes") }}
										</v-btn>
										<v-spacer></v-spacer>
									</v-card-actions>
								</v-card>
							</v-dialog>
							<v-dialog
								v-model="assignStudentDialog"
								max-width="800px"
								presistent
								transition="dialog-bottom-transition"
							>
								<template>
									<v-card>
										<v-tabs
											v-model="assignStudentTab"
											background-color="blue accent-4"
											centered
											dark
										>
											<v-tabs-slider></v-tabs-slider>
											<v-tab href="#tab-assign-student">
												{{ $t("quiz.assignStudents") }}
											</v-tab>
											<v-tab href="#tab-assigned-students">
												{{ $t("quiz.assignedStudents") }}
											</v-tab>
										</v-tabs>
										<v-tabs-items v-model="assignStudentTab">
											<v-tab-item
												key="assign-student"
												value="tab-assign-student"
												eager
											>
												<v-card class="p-4" flat>
													<v-form
														v-on:submit.prevent="getFreeStudents"
														ref="freeStudentsSearchForm"
													>
														<div class="row">
															<div class="col-md-4">
																<v-text-field
																	v-model="assignStudentSearch.user_id"
																	:label="$t('tables.id')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-4">
																<v-text-field
																	v-model="assignStudentSearch.name"
																	:label="$t('tables.name')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-4">
																<v-select
																	v-model="assignStudentSearch.gender"
																	v-bind:items="genders"
																	outlined
																	clearable
																	:label="$t('tables.gender')"
																>
																</v-select>
															</div>
														</div>
														<div class="row align-items-end mt-0">
															<div class="col-md-8">
																<p class="m-0">{{ $t("tables.age") }}</p>
																<v-range-slider
																	v-model="assignStudentSearch.age"
																	hide-details
																	min="1"
																	max="100"
																	class="align-center"
																>
																	<template v-slot:prepend>
																		<v-text-field
																			v-bind:value="assignStudentSearch.age[0]"
																			class="mt-0 pt-0"
																			hide-details
																			single-line
																			type="number"
																			style="width: 60px;"
																			v-on:change="
																				$set(assignStudentSearch.age, 0, $event)
																			"
																		>
																		</v-text-field>
																	</template>
																	<template v-slot:append>
																		<v-text-field
																			v-bind:value="assignStudentSearch.age[1]"
																			class="mt-0 pt-0"
																			hide-details
																			single-line
																			type="number"
																			style="width: 60px;"
																			v-on:change="
																				$set(assignStudentSearch.age, 1, $event)
																			"
																		>
																		</v-text-field>
																	</template>
																</v-range-slider>
															</div>
															<div class="col-md-4">
																<v-fab-transition>
																	<v-btn
																		type="button"
																		v-on:click="clearAssignStudentSearch"
																		class="mx-2"
																	>
																		{{ $t("clear") }}
																	</v-btn>
																</v-fab-transition>
																<v-fab-transition>
																	<v-btn
																		type="submit"
																		v-on:click="getFreeStudents"
																		color="primary"
																		class="mx-2"
																	>
																		{{ $t("Search") }}
																	</v-btn>
																</v-fab-transition>
															</div>
														</div>
													</v-form>
													<div class="row">
														<div class="col-md-12">
															<v-data-table
																v-model="toBeAssignedStudents"
																v-bind:headers="studentsHeaders"
																v-bind:items="freeStudents"
																item-key="id"
																show-select
																class="elevation-1"
																v-bind:server-items-length="totalFreeStudents"
																v-bind:options.sync="assignStudentOptions"
																v-on:update:options="getFreeStudents"
															>
															</v-data-table>
														</div>
													</div>
													<div class="d-flex justify-content-end mt-4">
														<v-fab-transition>
															<v-btn v-on:click="closeDialog" class="mx-2">
																{{ $t("close") }}
															</v-btn>
														</v-fab-transition>
														<v-fab-transition>
															<v-btn
																v-on:click="assignStudents"
																v-bind:disabled="!toBeAssignedStudents.length"
																color="primary"
																class="mx-2"
															>
																{{ $t("assign") }}
															</v-btn>
														</v-fab-transition>
													</div>
												</v-card>
											</v-tab-item>
											<v-tab-item
												key="assigned-student"
												value="tab-assigned-students"
												eager
											>
												<v-card class="p-4" flat>
													<v-form
														ref="assignedStudentsSearchForm"
														v-on:submit.prevent="getAssignedStudents"
													>
														<div class="row">
															<div class="col-md-2">
																<v-text-field
																	v-model="assignedStudentsSearch.user_id"
																	:label="$t('tables.id')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-4">
																<v-text-field
																	v-model="assignedStudentsSearch.name"
																	:label="$t('tables.name')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-3">
																<v-select
																	v-model="assignedStudentsSearch.gender"
																	v-bind:items="genders"
																	:label="$t('tables.gender')"
																	outlined
																	clearable
																>
																</v-select>
															</div>
															<div class="col-md-3">
																<v-select
																	v-model="
																		assignedStudentsSearch.student_exam_status
																	"
																	v-bind:items="quizStatuses"
																	:label="$t('quiz.quizStatus')"
																	outlined
																	clearable
																>
																</v-select>
															</div>
														</div>
														<div class="row align-items-end mt-0">
															<div class="col-md-8">
																<p class="m-0">{{ $t("tables.age") }}</p>
																<v-range-slider
																	v-model="assignedStudentsSearch.age"
																	min="1"
																	max="100"
																	hide-details
																>
																	<template v-slot:prepend>
																		<v-text-field
																			v-bind:value="
																				assignedStudentsSearch.age[0]
																			"
																			class="mt-0 pt-0"
																			hide-details
																			single-line
																			type="number"
																			style="width: 60px;"
																			v-on:change="
																				$set(
																					assignedStudentsSearch.age,
																					0,
																					$event
																				)
																			"
																		>
																		</v-text-field>
																	</template>
																	<template v-slot:append>
																		<v-text-field
																			v-bind:value="
																				assignedStudentsSearch.age[1]
																			"
																			class="mt-0 pt-0"
																			hide-details
																			single-line
																			type="number"
																			style="width: 60px;"
																			v-on:change="
																				$set(
																					assignedStudentsSearch.age,
																					1,
																					$event
																				)
																			"
																		>
																		</v-text-field>
																	</template>
																</v-range-slider>
															</div>
															<div class="col-md-4">
																<v-fab-transition>
																	<v-btn
																		type="button"
																		class="mx-2"
																		v-on:click="clearAssignedStudentsSearch"
																	>
																		{{ $t("clear") }}
																	</v-btn>
																</v-fab-transition>
																<v-fab-transition>
																	<v-btn
																		type="submit"
																		class="mx-2"
																		color="primary"
																		v-on:click="getAssignedStudents"
																	>
																		{{ $t("search") }}
																	</v-btn>
																</v-fab-transition>
															</div>
														</div>
													</v-form>
													<div class="row">
														<div class="col-md-12">
															<v-data-table
																v-bind:headers="assignedStudentsHeaders"
																v-bind:items="assignedStudents"
																item-key="id"
																show-select
																class="elevation-1"
																v-bind:server-items-length="
																	totalAssignedStudents
																"
																v-bind:options.sync="assignedStudentsOptions"
																v-on:update:options="getAssignedStudents"
															>
																<template v-slot:body="{ items }">
																	<tbody>
																		<tr
																			v-for="(item, index) in items"
																			:key="item.id"
																		>
																			<td>
																				<v-checkbox
																					v-model="
																						toBeUnassignedStudents[index]
																					"
																					:disabled="
																						item.quiz_status == 'Taken'
																					"
																				/>
																			</td>
																			<td>{{ item.id }}</td>
																			<td>{{ item.name }}</td>
																			<td>{{ item.gender }}</td>
																			<td>{{ item.age }}</td>
																			<td>{{ item.quiz_status }}</td>
																		</tr>
																	</tbody>
																</template>
															</v-data-table>
														</div>
													</div>
													<div class="d-flex justify-content-end mt-4">
														<v-fab-transition>
															<v-btn v-on:click="closeDialog" class="mx-2">
																{{ $t("close") }}
															</v-btn>
														</v-fab-transition>
														<v-fab-transition>
															<v-btn
																v-on:click="unAssignStudents"
																class="mx-2"
																color="primary"
																v-bind:disabled="!assignedStudents.length"
															>
																{{ $t("unassign") }}
															</v-btn>
														</v-fab-transition>
													</div>
												</v-card>
											</v-tab-item>
										</v-tabs-items>
									</v-card>
								</template>
							</v-dialog>
							<v-dialog
								v-model="assignStudentGroupDialog"
								max-width="800px"
								presistent
								transition="dialog-bottom-transition"
							>
								<template>
									<v-card>
										<v-tabs
											v-model="assignStudentGroupTab"
											background-color="blue accent-4"
											centered
											dark
										>
											<v-tabs-slider></v-tabs-slider>
											<v-tab href="#tab-assign-student-group">
												{{ $t("quiz.assignStudentGroups") }}
											</v-tab>
											<v-tab href="#tab-assigned-student-groups">
												{{ $t("quiz.assignedStudentGroups") }}
											</v-tab>
										</v-tabs>
										<v-tabs-items v-model="assignStudentGroupTab">
											<v-tab-item
												key="assign-student-group"
												value="tab-assign-student-group"
												eager
											>
												<v-card class="p-4" flat>
													<v-form
														v-on:submit.prevent="getFreeStudentGroups"
														ref="freeStudentgroupsSearchForm"
													>
														<div class="row">
															<div class="col-md-4">
																<v-text-field
																	v-model="
																		assignStudentGroupSearch.student_group_id
																	"
																	:label="$t('tables.id')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-4">
																<v-text-field
																	v-model="assignStudentGroupSearch.name"
																	:label="$t('tables.name')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-4">
																<v-fab-transition>
																	<v-btn
																		type="button"
																		v-on:click="clearAssignStudentGroupSearch"
																		class="mx-2"
																	>
																		{{ $t("clear") }}
																	</v-btn>
																</v-fab-transition>
																<v-fab-transition>
																	<v-btn
																		type="submit"
																		v-on:click="getFreeStudentGroups"
																		color="primary"
																		class="mx-2"
																	>
																		{{ $t("Search") }}
																	</v-btn>
																</v-fab-transition>
															</div>
														</div>
													</v-form>
													<div class="row">
														<div class="col-md-12">
															<v-data-table
																v-model="toBeAssignedStudentGroups"
																v-bind:headers="studentgroupsHeaders"
																v-bind:items="freeStudentGroups"
																item-key="id"
																show-select
																class="elevation-1"
																v-bind:server-items-length="
																	totalFreeStudentGroups
																"
																v-bind:options.sync="assignStudentGroupOptions"
																v-on:update:options="getFreeStudentGroups"
															>
															</v-data-table>
														</div>
													</div>
													<div class="d-flex justify-content-end mt-4">
														<v-fab-transition>
															<v-btn v-on:click="closeDialog" class="mx-2">{{
																$t("close")
															}}</v-btn>
														</v-fab-transition>
														<v-fab-transition>
															<v-btn
																v-on:click="assignStudentGroups"
																v-bind:disabled="
																	!toBeAssignedStudentGroups.length
																"
																color="primary"
																class="mx-2"
															>
																{{ $t("assign") }}
															</v-btn>
														</v-fab-transition>
													</div>
												</v-card>
											</v-tab-item>
											<v-tab-item
												key="assigned-student-groups"
												value="tab-assigned-student-groups"
												eager
											>
												<v-card class="p-4" flat>
													<v-form
														ref="assignedStudentGroupsSearchForm"
														v-on:submit.prevent="getAssignedStudentGroups"
													>
														<div class="row">
															<div class="col-md-2">
																<v-text-field
																	v-model="
																		assignedStudentGroupsSearch.student_group_id
																	"
																	:label="$t('tables.id')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-3">
																<v-text-field
																	v-model="assignedStudentGroupsSearch.name"
																	:label="$t('tables.name')"
																	outlined
																	clearable
																>
																</v-text-field>
															</div>
															<div class="col-md-3">
																<v-select
																	v-model="
																		assignedStudentGroupsSearch.quiz_status
																	"
																	v-bind:item="quizStatuses"
																	:label="$t('quiz.quizStatus')"
																	outlined
																	clearable
																>
																</v-select>
															</div>

															<div class="col-md-4">
																<v-fab-transition>
																	<v-btn
																		type="button"
																		class="mx-2"
																		v-on:click="
																			clearAssignedStudentGroupsSearch
																		"
																	>
																		{{ $t("clear") }}
																	</v-btn>
																</v-fab-transition>
																<v-fab-transition>
																	<v-btn
																		type="submit"
																		class="mx-2"
																		color="primary"
																		v-on:click="getAssignedStudentGroups"
																	>
																		{{ $t("search") }}
																	</v-btn>
																</v-fab-transition>
															</div>
														</div>
													</v-form>
													<div class="row">
														<div class="col-md-12">
															<v-data-table
																v-bind:headers="assignedStudentGroupsHeaders"
																v-bind:items="assignedStudentGroups"
																item-key="id"
																show-select
																class="elevation-1"
																v-bind:server-items-length="
																	totalAssignedStudentGroups
																"
																v-bind:options.sync="
																	assignedStudentGroupsOptions
																"
																v-on:update:options="getAssignedStudentGroups"
															>
																<template v-slot:body="{ items }">
																	<tbody>
																		<tr
																			v-for="(item, index) in items"
																			:key="item.id"
																		>
																			<td>
																				<v-checkbox
																					v-model="
																						toBeUnassignedStudentGroups[index]
																					"
																					:disabled="
																						item.quiz_status == 'Taken'
																					"
																				/>
																			</td>
																			<td>{{ item.id }}</td>
																			<td>{{ item.name }}</td>
																			<td>{{ item.description }}</td>
																			<td>{{ item.quiz_status }}</td>
																		</tr>
																	</tbody>
																</template>
															</v-data-table>
														</div>
													</div>
													<div class="d-flex justify-content-end mt-4">
														<v-fab-transition>
															<v-btn v-on:click="closeDialog" class="mx-2">{{
																$t("close")
															}}</v-btn>
														</v-fab-transition>
														<v-fab-transition>
															<v-btn
																v-on:click="unAssignStudentGroups"
																class="mx-2"
																color="primary"
																v-bind:disabled="!assignedStudentGroups.length"
															>
																{{ $t("unassign") }}
															</v-btn>
														</v-fab-transition>
													</div>
												</v-card>
											</v-tab-item>
										</v-tabs-items>
									</v-card>
								</template>
							</v-dialog>
						</v-toolbar>
					</template>
					<template v-slot:item.actions="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									class="mx-1"
									dense
									@click.stop="assignStudentGroup(item)"
									v-bind="attrs"
									v-on="on"
								>
									mdi-account-group
								</v-icon>
							</template>
							<span>{{ $t("quiz.assignStudentGroups") }}</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									class="mx-1"
									dense
									@click.stop="assignStudent(item)"
									v-bind="attrs"
									v-on="on"
								>
									mdi-clipboard-account
								</v-icon>
							</template>
							<span>{{ $t("quiz.assignStudents") }}</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									class="mx-1"
									v-bind="attrs"
									v-on="on"
									dense
									@click.stop="navigateToQuestions(item)"
								>
									mdi-list-status
								</v-icon>
							</template>
							<span>{{ $t("quiz.questions") }}</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									class="mx-1"
									v-bind="attrs"
									v-on="on"
									dense
									@click.stop="editQuiz(item)"
									:disabled="!!item.assigned_students_count"
								>
									mdi-pencil
								</v-icon>
							</template>
							<span>{{ $t("quiz.edit") }}</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									class="mx-1"
									v-bind="attrs"
									v-on="on"
									dense
									@click.stop="deleteQuiz(item)"
									:disabled="!!item.assigned_students_count"
								>
									mdi-delete
								</v-icon>
							</template>
							<span>{{ $t("quiz.delete") }}</span>
						</v-tooltip>
					</template>
				</v-data-table>
			</div>
		</div>
	</section>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import StudentsList from "../components/Dashboard/Quizzes/StudentsList.vue";
import StudentGroupsList from "../components/Dashboard/Quizzes/StudentGroupsList.vue";
import QuizModal from "../components/Dashboard/Quizzes/QuizModal.vue";
import moment from "moment";

export default {
	name: "QuizView",
	mixins: [GlobalMixin],
	components: {
		StudentsList,
		StudentGroupsList,
		QuizModal,
	},
	data() {
		return {
			institutes: null,
			currentIns: "",
			userObj: JSON.parse(localStorage.getItem("vuex")),
			quizDialog: false,
			emailDialog: false,
			previewDialog: false,
			assignStudentDialog: false,
			assignStudentGroupDialog: false,
			assignStudentTab: null,
			assignStudentGroupTab: null,
			deleteDialog: false,
			quizzes: [],
			toggledQuiz: [],
			courses: [],
			totalQuizzes: 0,
			viewMode: false,
			editMode: false,
			itemsPerPage: +this.$route.query.limit ? +this.$route.query.limit : 10,
			currentPage: 1,
			offset: +this.$route.query.offset ? +this.$route.query.offset : 0,

			// Preview Questions
			previewedQuiz: null,
			previewedQuestions: null,
			// Search params
			search: {
				quiz_id: null,
				name: "",
				course: null,
				is_published: null,
			},
			// Quizzies Data
			quiz: {
				id: null,
				assigned: false,
				course: {
					id: null,
				},
				description: "",
				duration_in_minutes: null,
				is_published: null,
				max_attempts: null,
				name: "",
				total_score: null,
				passing_score: null,
				// fail_score: null,
			},
			// Quiz Form
			quizValidation: true,
			quizFormRules: {
				quizNameRules: [v => !!v || "Quiz Name is required"],
				courseNameRules: [v => !!v || "Course Name is required"],
				totalScoreRules: [
					v => !!v || "Total Score is required",
					v => v > 0 || "Total Score must be a positive number",
					v =>
						v > this.quiz.passing_score ||
						"Total score must be greater than Pass score",
					// (v) =>
					//   v > this.quiz.fail_score ||
					//   "Total score must be greater than Fail score",
				],
				passScoreRules: [
					v => !!v || "Pass score is required",
					v => v > 0 || "Pass score must be a positive number",
					// (v) =>
					//   v > this.quiz.fail_score ||
					//   "Pass score must be greater than Fail score",
					v =>
						v < this.quiz.total_score ||
						"Pass score must be less than Total score",
				],
				// failScoreRules: [
				//   (v) => !!v || "Fail score is required",
				//   (v) => v > 0 || "Fail score must be a positive number",
				//   (v) =>
				//     v < this.quiz.passing_score ||
				//     "Fail score must be less than Pass score",
				//   (v) =>
				//     v < this.quiz.total_score ||
				//     "Fail score must be less than Total score",
				// ],
				timeRules: [
					v => !!v || "Time is required",
					v => v > 0 || "Time must be a positive number",
				],
				maxTrialsRules: [v => !!v || "Maximum Trials is required"],
				availabilityRules: [v => !!v || "Availability is required"],
			},
			// For deletion function only
			selectedQuiz: null,
			assignStudentSearch: {
				limit: 10,
				quiz_assigned_students: false,
			},
			toBeAssignedStudents: [],
			assignedStudentsSearch: {
				limit: 10,
				quiz_assigned_students: true,
			},
			toBeUnassignedStudents: [],
			freeStudents: [],
			assignedStudents: [],

			assignedStudents: [],
			totalFreeStudents: 0,
			totalAssignedStudents: 0,
			assignStudentOptions: {
				page: 1,
				itemsPerPage: 10,
				sortBy: [],
				sortDesc: [],
			},
			assignedStudentsOptions: {
				page: 1,
				itemsPerPage: 10,
				sortBy: [],
				sortDesc: [],
			},
			assignStudentGroupSearch: {
				limit: 10,
				quiz_assigned_students: false,
			},
			toBeAssignedStudentGroups: [],
			assignedStudentGroupsSearch: {
				limit: 10,
				quiz_assigned_groups: true,
			},
			toBeUnassignedStudentGroups: [],
			freeStudentGroups: [],
			assignedStudentGroups: [],
			totalFreeStudentGroups: 0,
			totalAssignedStudentGroups: 0,
			assignedStudentGroupsOptions: {
				page: 1,
				itemsPerPage: 10,
				sortBy: [],
				sortDesc: [],
			},
			assignStudentGroupOptions: {
				page: 1,
				itemsPerPage: 10,
				sortBy: [],
				sortDesc: [],
			},
		};
	},
	/**
	 * start initializing the component
	 */
	mounted() {
		// Get query params for the URL
		this.currentIns = +this.$route.query.ins
			? +this.$route.query.ins
			: this.getInstituteId;
		// Call institutes in case of super admin
		if (this.userObj.auth.user.user.user_type === "operator")
			this.getAllInstitutes();
		// Call getQuizzes function to get all quizzes at initializing
		this.getQuizzes(this.offset, this.itemsPerPage);
		this.getAllInstituteCourses();
	},
	methods: {
		clearAssignStudentSearch() {
			this.assignStudentSearch = {
				limit: this.assignStudentOptions.itemsPerPage,
				quiz_assigned_students: false,
			};
			this.assignStudentOptions.sortBy = [];
			this.assignStudentOptions.sortDesc = [];
			this.getFreeStudents();
		},
		clearAssignedStudentsSearch() {
			this.assignedStudentsSearch = {
				limit: 10,
				quiz_assigned_students: true,
			};
			this.assignedStudentsOptions.sortBy = [];
			this.assignedStudentsOptions.sortDesc = [];
			this.getAssignedStudents();
		},
		clearAssignStudentGroupSearch() {
			this.assignStudentGroupSearch = {
				limit: this.assignStudentGroupOptions.itemsPerPage,
				quiz_assigned_groups: false,
			};
			this.assignStudentGroupOptions.sortBy = [];
			this.assignStudentGroupOptions.sortDesc = [];
			this.getAllStudentGroups();
		},
		clearAssignedStudentGroupsSearch() {
			this.assignedStudentGroupsSearch = {
				limit: 10,
				quiz_assigned_groups: true,
			};
			this.assignedStudentGroupsOptions.sortBy = [];
			this.assignedStudentGroupsOptions.sortDesc = [];
			this.getAssignedStudentGroups();
		},
		/**
		 * Get all Institutes from the API
		 */
		getAllInstitutes() {
			this.axios(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
				.then(
					res =>
						(this.institutes = res.data.data.sort((a, b) =>
							a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1
						))
				)
				.catch(err => console.log(err));
		},
		/**
		 * Get all courses for a specific institute
		 */
		getAllInstituteCourses() {
			this.axios(
				`${process.env.VUE_APP_APIEndPoint}institutes/courses/?institute=${this.currentIns}`,
				this.headers
			)
				.then(res => {
					const {
						data: {
							data: { institute_courses: courses },
						},
					} = res;
					this.courses = courses.sort((a, b) =>
						a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1
					);
				})
				.catch(err => {
					console.error(err);
				});
		},
		/**
		 * Handle change institute and add it to the URL
		 */
		changeInstitute() {
			if (!this.currentIns) this.currentIns = 1;
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&offset=${this.offset}&limit=${this.itemsPerPage}`
			);
			// Rerender child components
			this.getQuizzes(this.offset, this.itemsPerPage);
			this.getAllInstituteCourses();
		},
		/**
		 * Get all quizzes
		 */
		getQuizzes(
			offset = 0,
			limit = this.itemsPerPage,
			sortBy,
			sortOrder,
			search
		) {
			const body = {
				institute: this.currentIns,
				offset,
				limit,
				sort_field: sortBy === "course.title" ? "course" : sortBy,
				sort_order:
					typeof sortOrder === "boolean"
						? sortOrder
							? "desc"
							: "asc"
						: undefined,
				quiz_id: search?.quiz_id ? search.quiz_id : undefined,
				name: search?.name ? search.name : undefined,
				is_published:
					typeof search?.is_published === "boolean"
						? search?.is_published
						: undefined,
				course: search?.course ? search.course : undefined,
			};
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/list/`,
					body,
					this.headers
				)
				.then(res => {
					this.quizzes = res.data.quizes;
					this.quizzes = this.quizzes.map(q =>
						q.is_published
							? { ...q, is_published: "Yes" }
							: { ...q, is_published: "NO" }
					);
					this.totalQuizzes = res.data.quiz_count;
				})
				.catch(err => this.formatErrors(err));
		},
		/**
		 * Start editing mode
		 * @param quiz quiz object
		 */
		editQuiz(quiz) {
			this.editMode = true;
			this.quizDialog = true;
			this.quiz = {
				...quiz,
				course: {
					id: quiz.course.id,
				},
			};
		},
		/**
		 * Start View mode
		 * @param quiz quiz object
		 */
		viewQuiz(quiz) {
			this.viewMode = true;
			this.quizDialog = true;
			this.quiz = {
				...quiz,
				course: {
					id: quiz.course.id,
				},
			};
		},
		/**
		 * Show delete dialog
		 * @param quiz quiz object
		 */
		deleteQuiz(quiz) {
			this.selectedQuiz = quiz;
			this.deleteDialog = true;
		},
		/**
		 * Confirmation for deleting selected quiz
		 * @param quiz quiz object
		 */
		deleteQuizConfirmation() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/delete/${this.selectedQuiz.id}/`,
					{
						institute: this.currentIns,
					},
					this.headers
				)
				.then(() => {
					this.getQuizzes(this.offset, this.itemsPerPage);
					Swal.fire({
						position: "center",
						icon: "success",
						title: "Quiz has been deleted successfully!",
						showConfirmButton: false,
						timer: 1500,
					});
					this.closeDialog();
				})
				.catch(err => this.formatErrors(err));
		},

		/**
		 * Confirmation for closing a dialog
		 */
		closeConfirmation(title) {
			Swal.fire({
				title,
				showDenyButton: true,
				confirmButtonText: this.$t("yes"),
				denyButtonText: this.$t("no"),
			}).then(result => {
				if (result.isConfirmed) {
					this.closeDialog();
				}
			});
		},

		/**
		 * Close any open dialog
		 * Reset quiz form
		 */
		closeDialog() {
			this.editMode = false;
			this.viewMode = false;
			this.quizDialog = false;
			this.emailDialog = false;
			this.previewDialog = false;
			this.deleteDialog = false;
			this.assignStudentDialog = false;
			this.assignStudentTab = "tab-assign-student";
			this.assignStudentGroupDialog = false;
			this.assignStudentGroupTab = "tab-assign-student-group";
			this.toBeAssignedStudentGroups = [];
			this.toBeAssignedStudents = [];
			this.toBeUnassignedStudentGroups = [];
			this.toBeUnassignedStudents = [];
			this.resetForm();
		},
		/**
		 * Add new quiz by getting form values
		 */
		addNewQuiz() {
			if (this.editMode) {
				const body = {
					...this.quiz,
					institute: this.currentIns,
					quiz_id: this.quiz.id,
					course: this.quiz.course.id,
				};
				this.axios
					.put(
						`${process.env.VUE_APP_APIEndPoint}quiz/update/${body.id}/`,
						body,
						this.headers
					)
					.then(() => {
						this.getQuizzes(this.offset, this.itemsPerPage);
						Swal.fire({
							position: "center",
							icon: "success",
							title: "Quiz has been edited successfully!",
							showConfirmButton: false,
							timer: 1500,
						});
						this.closeDialog();
					})
					.catch(err => this.formatErrors(err));
				return;
			}
			const body = {
				name: this.quiz.name,
				description: this.quiz.description,
				course: this.quiz.course.id,
				total_score: this.quiz.total_score,
				passing_score: this.quiz.passing_score,
				duration_in_minutes: this.quiz.duration_in_minutes,
				max_attempts: this.quiz.max_attempts,
				is_published: this.quiz.is_published === "Yes" ? true : false,
				institute: this.currentIns,
			};
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/create/`,
					body,
					this.headers
				)
				.then(() => {
					this.getQuizzes(this.offset, this.itemsPerPage);
					Swal.fire({
						position: "center",
						icon: "success",
						title: "Quiz has been added successfully!",
						showConfirmButton: false,
						timer: 2000,
					});
					this.closeDialog();
				})
				.catch(err => this.formatErrors(err));
		},
		/**
		 * Print toggled quiz
		 */
		printQuiz() {
			const body = {
				quiz_id: this.toggledQuiz[0].id,
				institute: this.currentIns,
				file_response_mode: "attachment",
			};

			this.axios
				.post(`${process.env.VUE_APP_APIEndPoint}quiz/pdf/`, body, {
					responseType: "blob",
				})
				.then(res => {
					// Create blob url
					const url = window.URL.createObjectURL(
						new Blob([res.data], { type: "application/pdf" })
					);

					// Embed blob url to iframe and print it after it's loaded
					const iframe = document.createElement("iframe");
					iframe.style.display = "none";
					iframe.src = url;
					document.body.appendChild(iframe);
					iframe.onload = function() {
						iframe.contentWindow.focus();
						iframe.contentWindow.print();
					};
					this.toggledQuiz = [];
				});
		},

		/**
		 * Preview toggled quiz
		 */
		previewQuiz() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/preview/`,
					{
						quiz_id: this.toggledQuiz[0].id,
						institute: this.currentIns,
					},
					this.headers
				)
				.then(res => {
					this.previewedQuiz = res.data.quiz;
					this.previewedQuestions = res.data.questions;
					this.previewDialog = true;
				});
		},
		/**
		 * Reset form values and form rules
		 */
		resetForm() {
			this.$refs.form?.reset();
			this.clearAssignStudentSearch();
			this.clearAssignedStudentsSearch();
			this.clearAssignStudentGroupSearch();
			this.clearAssignedStudentGroupsSearch();
		},
		/**
		 * Emits when Searching items and showing it into table
		 */
		searchQuizzes() {
			this.getQuizzes(
				this.offset,
				this.itemsPerPage,
				undefined,
				undefined,
				this.search
			);
		},
		/**
		 * Emits when Searching items and showing it into table
		 */
		clearQuizzes() {
			this.search.quiz_id = null;
			this.search.name = "";
			this.search.course = null;
			this.search.is_published = null;
			this.getQuizzes(this.offset, this.itemsPerPage);
		},
		/**
		 * Emits when one of the options properties is updated
		 * @param options table info
		 */
		updateQuizzes(options) {
			const sortBy = options.sortBy[0];
			const sortOrder = options.sortDesc[0];
			if (!this.currentIns) this.currentIns = this.getInstituteId;
			// Get neccessary values for table (itemsPerPage, currentPage, offset)
			this.offset = options.itemsPerPage * (options.page - 1);
			this.itemsPerPage = options.itemsPerPage;
			this.currentPage = this.offset ? this.offset / this.itemsPerPage + 1 : 1;
			// Change URL without reloading the page
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&offset=${this.offset}&limit=${this.itemsPerPage}`
			);
			// Get updated students with new params
			this.getQuizzes(
				this.offset,
				this.itemsPerPage,
				sortBy,
				sortOrder,
				this.search
			);
		},
		/**
		 * Navigate to Question page to get all quiz's questions
		 * @param quiz quiz object
		 */
		navigateToQuestions(quiz) {
			this.$router.push({
				name: "Questions",
				params: { name: quiz.name, id: quiz.id },
				query: { ins: this.currentIns, offset: 0, limit: 10 },
			});
		},
		assignStudent(quiz) {
			this.assignStudentDialog = true;
			this.quiz = { ...quiz };
			this.getAllStudents();
		},
		assignStudentGroup(quiz) {
			this.assignStudentGroupDialog = true;
			this.quiz = { ...quiz };
			this.getAllStudentGroups();
		},
		getAllStudents() {
			this.assignStudentSearch.quiz_id = this.quiz.id;
			this.assignStudentSearch.sort_field =
				this.assignStudentOptions.sortBy[0] === "name"
					? "first_name"
					: this.assignStudentOptions.sortBy[0];
			this.assignStudentSearch.sort_order = this.assignStudentOptions
				.sortDesc[0]
				? "desc"
				: "asc";
			if (
				this.assignStudentSearch.age &&
				!(
					this.assignStudentSearch.age[0] === 1 &&
					this.assignStudentSearch.age[1] === 1
				)
			) {
				this.assignStudentSearch.age_lt = this.assignStudentSearch.age[1];
				this.assignStudentSearch.age_gt = this.assignStudentSearch.age[0];
			}
			this.assignStudentSearch.institute = this.currentIns;
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/students/`,
					this.assignStudentSearch,
					this.headers
				)
				.then(res => {
					this.totalFreeStudents = res.data.total_records;
					this.freeStudents = res.data.students.map(student => {
						student.name = `${student.first_name} ${student.last_name}`;
						student.age = student.date_of_birth
							? parseInt(
									moment
										.duration(moment().diff(moment(student.date_of_birth)))
										.asYears()
							  )
							: "N/A";
						if (!student.gender) student.gender = "N/A";
						return student;
					});
					this.assignedStudentsSearch.quiz_id = this.quiz.id;
					this.assignedStudentsSearch.sort_field =
						this.assignedStudentsOptions.sortBy[0] === "name"
							? "first_name"
							: this.assignedStudentsOptions.sortBy[0];
					this.assignedStudentsSearch.sort_order = this.assignedStudentsOptions
						.sortDesc[0]
						? "desc"
						: "asc";
					if (
						this.assignedStudentsSearch.age &&
						!(
							this.assignedStudentsSearch.age[0] === 1 &&
							this.assignedStudentsSearch.age[1] === 1
						)
					) {
						this.assignedStudentsSearch.age_lt = this.assignedStudentsSearch.age[1];
						this.assignedStudentsSearch.age_gt = this.assignedStudentsSearch.age[0];
					}
					this.assignedStudentsSearch.institute = this.currentIns;
					this.axios
						.post(
							`${process.env.VUE_APP_APIEndPoint}quiz/students/`,
							this.assignedStudentsSearch,
							this.headers
						)
						.then(res => {
							this.totalAssignedStudents = res.data.total_records;
							this.assignedStudents = res.data.students.map(student => {
								student.name = `${student.first_name} ${student.last_name}`;
								student.age = student.date_of_birth
									? parseInt(
											moment
												.duration(moment().diff(moment(student.date_of_birth)))
												.asYears()
									  )
									: "N/A";
								if (!student.gender) student.gender = "N/A";
								return student;
							});
						});
				});
		},
		getAllStudentGroups() {
			this.assignStudentGroupSearch.quiz = this.quiz.id;
			this.assignStudentGroupSearch.sort_field = this.assignStudentGroupOptions.sortBy[0];
			this.assignStudentGroupSearch.sort_order = this.assignStudentGroupOptions
				.sortDesc[0]
				? "desc"
				: "asc";
			this.assignStudentGroupSearch.institute = this.currentIns;
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/student_groups/`,
					this.assignStudentGroupSearch,
					this.headers
				)
				.then(res => {
					this.totalFreeStudentGroups = res.data.total_records;
					this.freeStudentGroups = res.data.student_groups;
				});
			this.assignedStudentGroupsSearch.quiz = this.quiz.id;
			this.assignedStudentGroupsSearch.sort_field = this.assignedStudentGroupsOptions.sortBy[0];
			this.assignedStudentGroupsSearch.sort_order = this
				.assignedStudentGroupsOptions.sortDesc[0]
				? "desc"
				: "asc";
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/student_groups/`,
					this.assignedStudentGroupsSearch,
					this.headers
				)
				.then(res => {
					this.totalAssignedStudentGroups = res.data.total_records;
					this.assignedStudentGroups = res.data.student_groups;
				});
		},
		getFreeStudents() {
			this.assignStudentSearch.quiz_id = this.quiz.id;
			this.assignStudentSearch.limit = this.assignStudentOptions.itemsPerPage;
			this.assignStudentSearch.offset =
				this.assignStudentOptions.itemsPerPage *
				(this.assignStudentOptions.page - 1);
			this.assignStudentSearch.sort_field =
				this.assignStudentOptions.sortBy[0] === "name"
					? "first_name"
					: this.assignStudentOptions.sortBy[0];
			this.assignStudentSearch.sort_order = this.assignStudentOptions
				.sortDesc[0]
				? "desc"
				: "asc";
			if (
				this.assignStudentSearch.age &&
				!(
					this.assignStudentSearch.age[0] === 1 &&
					this.assignStudentSearch.age[1] === 1
				)
			) {
				this.assignStudentSearch.age_lt = this.assignStudentSearch.age[1];
				this.assignStudentSearch.age_gt = this.assignStudentSearch.age[0];
			}
			for (let i in this.assignStudentSearch) {
				if (i !== "quiz_assigned_students" && !this.assignStudentSearch[i]) {
					delete this.assignStudentSearch[i];
				}
			}
			this.assignStudentSearch.institute = this.currentIns;
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/students/`,
					this.assignStudentSearch,
					this.headers
				)
				.then(res => {
					this.totalFreeStudents = res.data.total_records;
					this.freeStudents = res.data.students.map(student => {
						student.name = `${student.first_name} ${student.last_name}`;
						student.age = student.date_of_birth
							? parseInt(
									moment
										.duration(moment().diff(moment(student.date_of_birth)))
										.asYears()
							  )
							: "N/A";
						if (!student.gender) student.gender = "N/A";
						return student;
					});
				});
		},
		getFreeStudentGroups() {
			this.assignStudentGroupSearch.quiz = this.quiz.id;
			this.assignStudentGroupSearch.sort_field = this.assignStudentGroupOptions.sortBy[0];
			this.assignStudentGroupSearch.sort_order = this.assignStudentGroupOptions
				.sortDesc[0]
				? "desc"
				: "asc";
			this.assignStudentSearch.institute = this.currentIns;
			this.assignStudentSearch.limit = this.assignStudentOptions.itemsPerPage;
			this.assignStudentGroupSearch.offset =
				this.assignStudentGroupOptions.itemsPerPage *
				(this.assignStudentGroupOptions.page - 1);
			for (let i in this.assignStudentGroupSearch) {
				if (i !== "quiz_assigned_groups" && !this.assignStudentGroupSearch[i]) {
					delete this.assignStudentGroupSearch[i];
				}
			}
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/student_groups/`,
					this.assignStudentGroupSearch,
					this.headers
				)
				.then(res => {
					this.totalFreeStudentGroups = res.data.total_records;
					this.freeStudentGroups = res.data.student_groups;
				});
		},
		getAssignedStudents() {
			this.assignedStudentsSearch.quiz_id = this.quiz.id;
			this.assignedStudentsSearch.limit = this.assignedStudentsOptions.itemsPerPage;
			this.assignedStudentsSearch.offset =
				this.assignedStudentsOptions.itemsPerPage *
				(this.assignedStudentsOptions.page - 1);
			this.assignedStudentsSearch.sort_field =
				this.assignedStudentsOptions.sortBy[0] === "name"
					? "first_name"
					: this.assignedStudentsOptions.sortBy[0];
			this.assignedStudentsSearch.sort_order = this.assignedStudentsOptions
				.sortDesc[0]
				? "desc"
				: "asc";
			if (
				this.assignedStudentsSearch.age &&
				!(
					this.assignedStudentsSearch.age[0] === 1 &&
					this.assignedStudentsSearch.age[1] === 1
				)
			) {
				this.assignedStudentsSearch.age_lt = this.assignedStudentsSearch.age[1];
				this.assignedStudentsSearch.age_gt = this.assignedStudentsSearch.age[0];
			}
			for (let i in this.assignedStudentsSearch) {
				if (!this.assignedStudentsSearch[i]) {
					delete this.assignedStudentsSearch[i];
				}
			}
			this.assignedStudentsSearch.institute = this.currentIns;
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/students/`,
					this.assignedStudentsSearch,
					this.headers
				)
				.then(res => {
					this.assignedStudents = res.data.students.map(student => {
						student.name = `${student.first_name} ${student.last_name}`;
						student.age = student.date_of_birth
							? parseInt(
									moment
										.duration(moment().diff(moment(student.date_of_birth)))
										.asYears()
							  )
							: "N/A";
						if (!student.gender) student.gender = "N/A";
						return student;
					});
				});
		},
		getAssignedStudentGroups() {
			this.assignedStudentGroupsSearch.quiz = this.quiz.id;
			this.assignedStudentGroupsSearch.sort_field = this.assignedStudentGroupsOptions.sortBy[0];
			this.assignedStudentGroupsSearch.sort_order = this
				.assignedStudentGroupsOptions.sortDesc[0]
				? "desc"
				: "asc";
			this.assignedStudentGroupsSearch.institute = this.currentIns;
			this.assignedStudentGroupsSearch.limit = this.assignedStudentGroupsOptions.itemsPerPage;
			this.assignedStudentGroupsSearch.offset =
				this.assignedStudentGroupsOptions.itemsPerPage *
				(this.assignedStudentGroupsOptions.page - 1);
			for (let i in this.assignedStudentGroupsSearch) {
				if (!this.assignedStudentGroupsSearch[i]) {
					delete this.assignedStudentGroupsSearch[i];
				}
			}
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/student_groups/`,
					this.assignedStudentGroupsSearch,
					this.headers
				)
				.then(res => {
					this.totalAssignedStudentGroups = res.data.total_records;
					this.assignedStudentGroups = res.data.student_groups;
				});
		},
		assignStudents() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/assign_students/`,
					{
						quiz: this.quiz.id,
						students: this.toBeAssignedStudents.map(student => student.id),
						institute: this.currentIns,
					},
					this.headers
				)
				.then(res => {
					Swal.fire({
						position: "center",
						icon: "success",
						title: "Students assigned to quiz successfully!",
						showConfirmButton: false,
						timer: 1500,
					});
					this.closeDialog();
					this.getQuizzes(0, this.itemsPerPage);
				})
				.catch(err => this.formatErrors(err));
		},
		assignStudentGroups() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/assign_student_groups/`,
					{
						quiz: this.quiz.id,
						students_groups: this.toBeAssignedStudentGroups.map(
							group => group.id
						),
						institute: this.currentIns,
					},
					this.headers
				)
				.then(res => {
					Swal.fire({
						position: "center",
						icon: "success",
						title: "Student Groups assigned to quiz successfully!",
						showConfirmButton: false,
						timer: 1500,
					});
					this.closeDialog();
					this.getQuizzes(0, this.itemsPerPage);
					this.toBeAssignedStudentGroups = [];
				})
				.catch(err => this.formatErrors(err));
		},
		unAssignStudents() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/unassign_students/`,
					{
						quiz: this.quiz.id,
						students: this.toBeUnassignedStudents
							.map((student, index) => this.assignedStudents[index]?.id)
							.filter(id => !!id),
						institute: this.currentIns,
					},
					this.headers
				)
				.then(res => {
					Swal.fire({
						position: "center",
						icon: "success",
						title: "Students unassigned from quiz successfully!",
						showConfirmButton: false,
						timer: 1500,
					});
					this.closeDialog();
					this.getQuizzes(0, this.itemsPerPage);
					this.toBeUnassignedStudents = [];
				})
				.catch(err => this.formatErrors(err));
		},
		unAssignStudentGroups() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/unassign_students_group/`,
					{
						quiz: this.quiz.id,
						students_groups: this.toBeUnassignedStudentGroups
							.map((group, index) => this.assignedStudentGroups[index]?.id)
							.filter(id => !!id),
						institute: this.currentIns,
					},
					this.headers
				)
				.then(res => {
					Swal.fire({
						position: "center",
						icon: "success",
						title: "Sutent Groups unassigned from quiz successfully!",
						showConfirmButton: false,
						timer: 1500,
					});
					this.closeDialog();
					this.getQuizzes(0, this.itemsPerPage);
					this.toBeUnassignedStudentGroups = [];
				})
				.catch(err => this.formatErrors(err));
		},
	},
	computed: {
		availability() {
			return [
				{ text: `${this.$t("yes")}`, value: true },
				{ text: `${this.$t("no")}`, value: false },
			];
		},

		/**
		 * Check if user is super admin or not
		 */
		checkUser() {
			return this.userObj.auth.user.user.user_type === "operator";
		},

		/**
		 * Check quiz form disability
		 */
		checkForm() {
			const newValues = [];
			Object.entries(this.quiz).forEach(e => {
				if (
					e[0] == "description" ||
					e[0] == "id" ||
					e[0] == "assigned" ||
					e[0] == "valid_from" ||
					e[0] == "valid_to" ||
					e[0] == "assigned_students_count"
				)
					return;
				if (e[0] === "course") return newValues.push(e[1]?.id);
				return newValues.push(e[1]);
			});
			return !newValues.every(v => !!v);
		},

		/**
		 * Generate pop up title in case of new quiz or edit quiz
		 */
		dialogTitle() {
			if (this.viewMode) {
				return this.quiz.name[0].toUpperCase() + this.quiz.name.slice(1);
			}
			return !this.editMode
				? `${this.$t("quiz.newQuiz")}`
				: `${this.$t("quiz.editQuiz")}`;
		},

		/**
		 * Generate pop up sibmission in case of new quiz or edit quiz
		 */
		formSubmission() {
			return !this.editMode
				? `${this.$t("quiz.createQuiz")}`
				: `${this.$t("quiz.editQuiz")}`;
		},

		/**
		 * @returns institute id depends on role of the user
		 */
		getInstituteId() {
			return this.userObj.auth.user.user.user_type === "operator"
				? 1
				: +this.userObj.auth.user.user.username.slice("").at(-1);
		},

		/**
		 * calculate quiz name when opening email dialog
		 */
		sendQuizName() {
			// return this.toggledQuiz[0]?.name
			// 	? `Send ${this.toggledQuiz[0].name} by Email`
			// 	: "Send Quiz by Email";
			return this.toggledQuiz[0]?.name
				? this.$t("quiz.sendQuizByEmail")
				: this.$t("quiz.sendQuizByEmail");
		},

		/**
		 * Translations for table
		 * @returns []
		 */
		tableHeaders() {
			return [
				{ text: this.$t("tables.id"), value: "id" },
				{ text: this.$t("tables.name"), value: "name" },
				{ text: this.$t("tables.courseName"), value: "course.title" },
				{ text: this.$t("tables.published"), value: "is_published" },
				{ text: this.$t("tables.actions"), value: "actions", sortable: false },
			];
		},
		studentgroupsHeaders() {
			return [
				{
					text: this.$t("tables.id"),
					value: "id",
				},
				{
					text: this.$t("tables.name"),
					value: "name",
				},
				{
					text: this.$t("tables.description"),
					value: "description",
				},
			];
		},
		assignedStudentGroupsHeaders() {
			return [
				{
					text: this.$t("tables.id"),
					value: "id",
				},
				{
					text: this.$t("tables.name"),
					value: "name",
				},
				{
					text: this.$t("tables.description"),
					value: "description",
				},
				{
					text: this.$t("quiz.quizStatus"),
					value: "quiz_status",
				},
			];
		},
		studentsHeaders() {
			return [
				{
					text: this.$t("tables.id"),
					value: "id",
				},
				{
					text: this.$t("tables.name"),
					value: "name",
				},
				{
					text: this.$t("tables.gender"),
					value: "gender",
				},
				{
					text: this.$t("tables.age"),
					value: "age",
				},
			];
		},
		assignedStudentsHeaders() {
			return [
				{
					text: this.$t("tables.id"),
					value: "id",
				},
				{
					text: this.$t("tables.name"),
					value: "name",
				},
				{
					text: this.$t("tables.gender"),
					value: "gender",
				},
				{
					text: this.$t("tables.age"),
					value: "age",
				},
				{
					text: this.$t("quiz.quizStatus"),
					value: "quiz_status",
				},
			];
		},
	},

	watch: {
		/**
		 * Reset the dialog and all values of fields
		 * @param newVal boolean
		 */
		quizDialog(newVal) {
			if (newVal === false) {
				this.resetForm();
				this.quiz = {
					id: null,
					assigned: false,
					course: {
						id: null,
					},
					description: "",
					duration_in_minutes: null,
					is_published: null,
					max_attempts: null,
					name: "",
					total_score: null,
					passing_score: null,
					// fail_score: null,
				};
				this.viewMode = false;
				this.editMode = false;
				this.selectedQuiz = null;
			}
		},

		/**
		 * Change quiz id whenever selecting another quiz
		 * @param newVal boolean
		 */
		emailDialog(newVal) {
			if (!newVal) this.toggledQuiz = [];
		},
		previewDialog(newVal) {
			if (!newVal) this.toggledQuiz = [];
		},
	},
};
</script>

<!-- @TODO to be moved to global style file when created -->
<style scoped lang="scss">
.search-box {
	.v-text-field__details {
		display: none !important;
	}
}

.v-toolbar__title {
	font-size: 30px !important;
}

.v-autocomplete.v-input > .v-input__control > .v-input__slot {
	border: none;
}

.v-data-table__wrapper {
	table {
		td,
		th {
			padding: 5px 4px 5px 0 !important;
			max-width: 150px;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		td:first-of-type,
		th:first-of-type {
			padding: 5px 10px !important;
		}

		thead {
			tr {
				th {
					max-width: fit-content;
					font-size: 14px !important;
				}
			}
		}

		tbody {
			tr {
				cursor: pointer;

				&:hover {
					color: #7caa2d;
				}
			}

			.v-icon:hover {
				color: #7caa2d;
			}
		}
	}
}

@media all and (max-width: 1200px) and (min-width: 992px) {
	.v-toolbar__title {
		font-size: 22px !important;
	}
	.v-data-table {
		.v-data-table__wrapper {
			table {
				td:not(:last-of-type),
				th {
					padding: 5px 4px 5px 0 !important;
					max-width: 70px;
					overflow: hidden;
					text-overflow: ellipsis;
					button {
						margin: 0;
						padding: 0;
					}
				}
				td:first-of-type,
				th:first-of-type {
					padding: 5px 3px !important;
				}
				th {
					max-width: fit-content;
				}
			}
		}
	}
}
</style>
